import { render, staticRenderFns } from "./AppLayoutNavButtons.vue?vue&type=template&id=768caa24"
import script from "./AppLayoutNavButtons.vue?vue&type=script&lang=js"
export * from "./AppLayoutNavButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports